<template>
  <div class="index">
    <div class="tips-header">您要卖什么商品</div>
    <div class="sell-input-contain">
      <form action="javascript:void(0);">
        <input v-model="searchInput" @keyup.enter="search" ref="searchInput" class="sell-input"  placeholder="输入您要销售的商品名称"
          type="search">
      </form>
    </div>
    <div class="tips-header">您要卖什么价位</div>
    <div class="price-contain">
      <div v-for="(val, i) in $_.chunk(showData(priceList, 3), 3)" :key="i" class="flex between price-line">
        <div v-for="(item, index) in val" :key="index" class="item-price"
          :class="{'item-price-bg': item, 'active-price-item': i*3+index===activePrice}"
          @click="togglePrice(item, i, index)">
          {{item&&item.label}}
        </div>
      </div>
    </div>
    <div class="find-button" @click="search()">查找带货达人</div>
    <div class="quickly-find">
      <div class="quickly-find-title">
        快捷选择商品
      </div>
      <div class="content-border"></div>
      <div style="height: .28rem"></div>
      <div class="list-quickly">
        <div v-for="(itemQuickly, indexQuickly) in goodsList" :key="indexQuickly">
          <div class="item-quickly-title">{{itemQuickly.title}}</div>
          <div class="item-data-contain">
            <div v-for="(val, i) in $_.chunk(showData(itemQuickly.data, 5), 5)" :key="i" class="flex between quickly-line">
              <div v-for="(item, index) in val" :key="index" @click="selectGoods(item)" class="quickly-data-item">
                {{item&&item.label}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {goodsList, priceList} from './data'
  
  export default {
    data() {
      return {
        priceList,
        goodsList,
        activePrice: 0,
        selectPrice: priceList[0],
        searchInput: '',
        params: {
          page: 25,
          index: 1,
          sort: 'fans',
          order: 'desc',
          name: '',
          priceIndex: 0
        }
      }
    },
    methods: {
      togglePrice(item, i, index) {
        this.activePrice = i * 3 + index
        this.params = {
          ...this.params,
          priceIndex: item.value
        }
      },
      selectGoods(val) {
        this.params = {
          ...this.params,
          name: val.value,
          priceIndex: 0
        }
        this.query()
      },
      search() {
        // 没有登录先登录
        if(this.$store.state.userLevel) {
          if(this.searchInput) {
            this.params = {
              ...this.params,
              name: this.searchInput
            }
            this.query()
          }else {
            this.$toast('请输入你要卖的商品')
          }
        }else {
          this.$store.commit('WRITEOVERLAYSHOW', {status: true})
        }
      },
      query() {
        this.$router.push(`/zr/result?name=${this.params.name}&priceIndex=${this.params.priceIndex}`)
      },
      showData(val, valLength) {
        return val.concat(new Array(Math.abs(valLength - (val.length % valLength || valLength))))
      }
    },
  }
</script>

<style lang="less" scoped>
  .index {
    font-size: .28rem;
    background: #EEF2F7;
    padding-bottom: 1rem;
    .tips-header {
      color: #4A4A4A;
      font-size: .28rem;
      padding-top: 0.6rem;
      padding-left: .3rem;
      padding-bottom: 0.3rem;
    }
    .sell-input-contain {
      width: 6.9rem;
      height: 1rem;
      margin: 0 auto;
      background: #fff;
      border-radius: .08rem;
      padding: 0.2rem;

      .sell-input {
        width: 6.5rem;
        height: .6rem;
        color: #A1AEBF;
        border: none;
        line-height: 0.6rem;
      }
    }
    .price-contain {
      width: 6.9rem;
      margin: 0 auto;

      .price-line {
        margin-bottom: 0.3rem;
      }

      .item-price {
        width: 2rem;
        height: 0.5rem;
        text-align: center;
        color: #A1AEBF;
        font-size: .24rem;
        line-height: 0.5rem;
        border-radius: .25rem;
      }

      .item-price-bg {
        background: rgba(42, 137, 244, .1);
      }

      .item-price.active-price-item {
        color: #2A89F4;
      }
    }
    .find-button {
      width:6.90rem;
      height:1.00rem;
      background:linear-gradient(180deg,rgba(84,190,250,1) 0%,rgba(42,137,244,1) 100%);
      border-radius:.08rem;
      margin: 0 auto;
      margin-top: 0.6rem;
      text-align: center;
      line-height: 1rem;
      font-size: .28rem;
      color: #fff;
    }
    .quickly-find {
      background: #fff;
      padding: 0.3rem;
      position: relative;
      margin-top: 0.6rem;
      .quickly-find-title {
        color: #4A4A4A;
        font-size: .36rem;
        text-align: center;
        width: 2.40rem;
        left: 2.55rem;
        background: #fff;
        z-index: 1;
        top: 0.28rem;
        position: absolute;
        height: 0.5rem;
        line-height: 0.5rem;
      }
      .content-border {
        position: absolute;
        width: 6.9rem;
        height: .05rem;
        background:linear-gradient(270deg,rgba(84,190,250,0.2) 0%,rgba(42,137,244,1) 33%, rgba(42,137,244,1) 66%, rgba(84,190,250,0.2) 100%);
        top: 0.53rem;
      }
      .list-quickly {
        .item-quickly-title {
          margin-top: 0.6rem;
        }
        .item-data-contain {
          
          .quickly-line {
            margin-top: 0.3rem;
            .quickly-data-item {
              width:1.20rem;
              height:.50rem;
              background:rgba(202,211,223,.3);
              border-radius:.30rem;
              text-align: center;
              line-height: 0.5rem;
              color: #A1AEBF;
              font-size: .24rem;
            }
          }
        }
      }
    }
  }
</style>